import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import { UseGetAllActiveMealAds } from "../../../api/useMeal";
import { useTranslation } from "react-i18next";

const SearchedRealatedProduct = () => {
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>();
    const [selectedCategory, setSelectedCategory] = useState<any>();
    const [categoriesMap, setCategoriesMap] = useState<Map<string, any[]>>(new Map());
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                UseGetAllActiveMealAds().then((response: any) => {
                    if (response && response.status === 200) {
                        const fetchedData = response.result;

                        const categoriesMap = new Map<string, any[]>();

                        // fetchedData.length > 0 && setSelectedCategory(fetchedData[0]?.category);

                        fetchedData && fetchedData.length > 0 && fetchedData.forEach((item: any) => {
                            if (item.data.validUntilTime !== null) {
                                const validUntilTime = new Date();
                                const [hours, minutes] = item.data.validUntilTime.split(":");
                                validUntilTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);

                                const currentTime = new Date();

                                if (currentTime > validUntilTime) {
                                    // return;
                                }
                            }

                            item.category.forEach((category: string) => {
                                const normalizedCategory = category.toLowerCase();
                                if (!categoriesMap.has(normalizedCategory)) {
                                    categoriesMap.set(normalizedCategory, []);
                                }
                                categoriesMap.get(normalizedCategory)!.push(item);
                            });
                        
                        });
                        Array.from(categoriesMap.keys()).length > 0 && Array.from(categoriesMap.keys()).map((category, index) => {
                            index === 0 && setSelectedCategory(category);
                            // setSelectedCategory()
                        });
                        setCategoriesMap(categoriesMap);
                    }
                });
                /*const response = await getData(dispatch);
                if (response) {
                    console.log("response: ", response);
                    setData(response);
                    response.forEach((item: any) => {
                        if (item.category === response[0].category) {
                            setSelectedCategory(item);
                        }
                    });
                }*/
            }
            catch (error) {
                console.log(error);
            }
        }
        fetchData().then();
    }, [dispatch]);

    const handleShowItemDetails = (category: string, name: string) => () => {
        navigate(`/food/${category}/${name}`);
    }

    const handleCategoryClick = (item: any) => {
        setSelectedCategory(item);
    };
    
    return (
        <div className="searchedProduct">
            <div className="searchedProduct__container">
                <div className="searchedProduct__container_title">
                    <span>{t('food.relatedProduct')}</span>
                    <span></span>
                </div>
                <div className="searchedProduct__container_tags">
                    {
                        Array.from(categoriesMap.keys()).map((category, index) => (
                                <div
                                    className={`searchedProduct__container_tags_tag ${category === selectedCategory ? 'active' : ''}`}
                                    key={index}
                                    onClick={() => handleCategoryClick(category)}
                                >
                                    <span>{category}</span>
                                </div>

                        ))
                    }
                </div>
              {
                selectedCategory && categoriesMap && Array.from(categoriesMap.keys()).length > 0 && (
                  <div className="searchedProduct__container_dishes">
                      {categoriesMap.get(selectedCategory)?.map((item, itemIndex) => {
                          // console.log("item: ", item);
                          return (
                            <div
                              className="searchedProduct__container_dishes_dish"
                              key={itemIndex}
                              onClick={handleShowItemDetails(selectedCategory.toLowerCase().replace(/\s/g, "-"),
                                item.data._id)}
                            >
                                <div className="searchedProduct__container_dishes_dish_image">
                                    <img src={item.data.image} alt={item.data.name} />
                                    <div className="searchedProduct__container_dishes_dish_image_reservation">
                                        <div className="searchedProduct__container_dishes_dish_image_reservation_content">
                                            <span>{item.isDineIn ? t('const.dineIn') : t('const.takeOut')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="searchedProduct__container_dishes_dish_place">
                                    <span>{item.data?.restaurantId?.address?.name}</span>
                                </div>

                                <div className="searchedProduct__container_dishes_dish_data">
                                    <div className="searchedProduct__container_dishes_dish_data_name">
                                        <span>{item.data.name}</span>
                                    </div>
                                    {
                                        item.isDineIn ? (
                                          <div className="searchedProduct__container_dishes_dish_data_price">
                                              <div className="searchedProduct__container_dishes_dish_data_price_discount">
                                                <span>{item.data.discount}% {t('const.discount')}</span>
                                              </div>
                                          </div>
                                        ) : (
                                          <div className="searchedProduct__container_dishes_dish_data_price">
                                              <div className="searchedProduct__container_dishes_dish_data_price_before">
                                                <span>€{item.data.priceBefore}</span>
                                              </div>
                                              <div className="searchedProduct__container_dishes_dish_data_price_discount">
                                                <span>€{item.data.priceNow}</span>
                                              </div>
                                          </div>
                                        )
                                    }
                                </div>
                            </div>
                          )
                      })}
                  </div>
                )
              }
            </div>
        </div>
    );
};

export default SearchedRealatedProduct;